import type { FC } from 'react';
import { Box, Typography } from '@material-ui/core';

interface PropsSeguimientoMeta {
  meta: { amount: number; description: string };
}

const SeguimientoMeta: FC<PropsSeguimientoMeta> = ({ meta }) => {
  const title = 'Meta de Facturación';
  const amount = `S/ ${meta.amount} ${meta.description}`;
  return (
    <Box textAlign="center">
      <Box
        borderRadius="20px"
        bgcolor="#dbeef4"
        textAlign="center"
        p={4}
        mt={4}
        mb={1}
      >
        <Typography variant="h4" align="center" color="#031f5e">
          {title}
        </Typography>
        <Typography variant="h4" align="center" color="#031f5e">
          {amount}
        </Typography>
      </Box>
    </Box>
  );
};

export default SeguimientoMeta;
